import { css } from '@emotion/react';
import { theme } from 'global';

export const helperText = css`
  display: flex;
  align-items: baseline;
  margin: 4px 0 0;
  color: ${theme.colors.danger};
  font-size: ${theme.fontSizes.body4};
  line-height: ${theme.lineHeights.body4};
  font-weight: ${theme.fontWeights.body4};
  padding-top: 4px;

  .errorIcon {
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    position: relative;
    top: 3px;
    margin-right: 4px;
    fill: ${theme.colors.danger};
  }
`;

export const textfield = css`
  .MuiInputAdornment-root {
    display: none;
  }

  .MuiFormHelperText-root {
    ${helperText};
  }

  .MuiInputLabel-formControl {
    height: 1.2em;
  }

  .MuiInputLabel-root.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75);
  }
`;

export const textfieldNoMargin = css`
  margin: 0 !important;
  margin-top: 16px !important;
`;

export const radioStepForm = css`
  .MuiFormControl-root {
    margin-top: 0 !important;
  }
`;

export const textFieldSelect = css`
  margin: 0 0 1.25rem 0 !important;

  & > label {
    line-height: 1rem;
  }

  .MuiFormHelperText-root {
    ${helperText};
  }
`;

export const privacyPolicyCheckbox = css`
  display: flex;
  align-items: flex-start;
  margin: 1px 0 0;
  & > .MuiCheckbox-root {
    margin-right: 0;
  }

  svg {
    width: 1.125rem;
    height: 1.125rem;
  }

  & .MuiFormControlLabel-label {
    p {
      margin: 0;
      font-family: ${theme.fonts.body2.family};
      font-weight: ${theme.fontWeights.normal};
      font-size: ${theme.fontSizes.body2};
      line-height: ${theme.lineHeights.body2};
      letter-spacing: ${theme.letterSpacings.body2};
      color: ${theme.colors.neutral[500]};
      padding-top: 7px;
    }

    a {
      color: ${theme.colors.primary.medium};
      text-decoration: none;
      font-family: ${theme.fonts.body1.family};
      font-weight: ${theme.fontWeights.medium};
      font-size: ${theme.fontSizes.body1};
      line-height: ${theme.lineHeights.body1};
      letter-spacing: ${theme.letterSpacings.body1};

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const closeIcon = css`
  color: ${theme.colors.neutral[500]};
`;

export const tooltip = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 0.5rem;

  svg {
    cursor: pointer;
    color: ${theme.colors.neutral[500]};
    width: 1rem;
    height: 1rem;
  }
`;
